<template>
	<div class="login-container d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-transparent">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>

		<section class="flex-shrink-0 container">
			<div class="form-signin card">
				<h5 class="text-center mb-3">Enter Password</h5>
				<div class="form-group">
					<label>Password</label>
					<div class="input-group align-items-center" id="show_hide_password">
						<input
							class="form-control "
							:type="textInputType"
							@focus="passwordFocus"
							v-model="password"
						/>
						<div class="input-group-addon">
							<a
								><i
									class="fa fa-eye-slash"
									aria-hidden="true"
									@click="switchPasswordType"
								></i
							></a>
						</div>
					</div>
				</div>
				<div class="form-group">
					<label>Confirm Password</label>
					<div class="input-group align-items-center" id="show_hide_password">
						<input
							class="form-control "
							type="password"
							@focus="passwordFocus"
							v-model="repassword"
						/>
					</div>
					<label class="text-center pt-3" v-if="showPasswordValidBlank"
						>Password can't be blank</label
					>
					<label class="text-center pt-3" v-if="showPasswordMismatch"
						>Password is not matching</label
					>
				</div>
				<button
					class="btn btn-outline-light btn-block text-uppercase"
					v-on:click.stop.prevent="updatepassword"
				>
					Continue
				</button>
			</div>
			<p class="text-center text-white pt-4">Download App</p>
			<p class="text-center text-white">
				<img
					src="../../assets/img/google-play.png"
					alt=""
					class="cursor-pointer"
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>
		<footer class="footer mt-auto py-3">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>

<style></style>

<script>
export default {
	name: "updatepassword",
	components: {},
	mounted() {
		window.scroll(0, 0);
	},
	created() {
		   this.$store.commit("showPopup", false);
		this.updateFrom = this.$route.params.id;
	},
	methods: {
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		passwordFocus() {
			this.showPasswordValidBlank = false;
			this.showPasswordMismatch = false;
		},
		switchPasswordType() {
			this.textInputType =
				this.textInputType == "password" ? "text" : "password";
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		validatepassword() {
			if (this.password == "" || this.repassword == "") {
				this.showPasswordValidBlank = true;
				return false;
			}
			if (this.password != this.repassword) {
				this.showPasswordMismatch = true;
				return false;
			} else {
				return true;
			}
		},
		updatepassword() {
			if (this.validatepassword()) {
			} else {
				return false;
			}
			this.isActive = true;
			this.showupdatepasswordErr = false;
			var self = this;
			if (this.doupdatepassword) {
				var dataToSend = {
					oldPassword: this.password,
				};

				if (this.updateFrom == "em") {
					this.$store.commit("updateResetField", {
						type: "password",
						value: this.password,
					});
					this.$store.commit("setLoader", true);
					this.$store
						.dispatch("resetpassword")
						.then((res) => {
							this.showupdatepasswordErr = true;
							this.updatepasswordErr = res.message;
							this.$store.commit("setNotification", res.message);

							setTimeout(function() {
								self.$store.dispatch("logout").then((res) => {
									if (res == "true") {
										self.$store.commit("setLoader", false);
										self.$router.push("/login");
									}
								});
							}, 5000);
						})
						.catch((err) => {
							this.$store.commit("setLoader", false);
							this.showupdatepasswordErr = true;
							this.updatepasswordErr = err.response.data.error.message;
						});
				} else {
					this.$store.commit("updateResetField", {
						type: "password",
						value: this.password,
					});
					self.$router.push("/reset-phone-code");
				}
			}
		},
	},

	data() {
		return {
			updateFrom: "",
			showupdatepasswordErr: false,
			textInputType: "password",
			textInputTypeCnf: "password",
			updatepasswordErr: "",
			isActive: false,
			doupdatepassword: true,
			showPasswordValidBlank: false,
			showPasswordMismatch: false,
			userid: "",
			password: "",
			repassword: "",
			idParamUid: "",
			idParamToken: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
